export default __webpack_public_path__ + "static/serviceImg-16e3c16511d3ca41f200f851da4f770e.png";